import React, { Fragment, useEffect, useState } from "react";
import { Button, Nav, NavDropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsArrowBarLeft, BsArrowBarRight } from "react-icons/bs";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../hooks/apiClient";

const renderMenuRoot = (menuCollapsed, item, index, history) => (
  <Fragment key={item.title}>
    <hr className="sidebar-divider" />
    {menuCollapsed ? (
      <OverlayTrigger
        placement="right"
        delay={{ show: 0, hide: 10 }}
        overlay={<Tooltip id="button-tooltip">{item.title}</Tooltip>}
      >
        <NavDropdown
          eventkey={item.title}
          title={
            <span>
              <span>
                <i className={item.icon} />
              </span>
              <span className="ocultarNoToggle">{item.title}</span>
            </span>
          }
        >
          {item.itens.map((itemNivel1, indexNivel1) => (
            <NavDropdown.Item
              key={itemNivel1.title}
              eventkey={indexNivel1}
              onClick={() => history.push(itemNivel1.url)}
            >
              {itemNivel1.title}
            </NavDropdown.Item>
          ))}
        </NavDropdown>
      </OverlayTrigger>
    ) : (
      <NavDropdown
        eventkey={index}
        title={
          <span>
            <span>
              <i className={item.icon} />
            </span>
            <span className="ocultarNoToggle">{item.title}</span>
          </span>
        }
      >
        {item.itens.map((itemNivel1, indexNivel1) => (
          <NavDropdown.Item key={itemNivel1.title} eventkey={indexNivel1} onClick={() => history.push(itemNivel1.url)}>
            {itemNivel1.title}
          </NavDropdown.Item>
        ))}
      </NavDropdown>
    )}
  </Fragment>
);

const SideMenu = ({ history }) => {
  const [menu, setMenu] = useState([]);
  const [menuCollapsed, setMenuCollapsed] = useState(false);
  const { request: requestMenu, data: dataMenu, errors: errorMenu } = useApiClient();

  useEffect(() => {
    const usuario = JSON.parse(localStorage.getItem("user"));
    if (usuario) requestMenu(apiRoutes.usuarios.menu.consulta, usuario.permissoes);
  }, [requestMenu]);

  useEffect(() => {
    if (dataMenu) {
      setMenu(dataMenu.result.itens);
    } else if (errorMenu) {
      toast.error("Erro ao carregar o menu da aplicação");
    }
  }, [dataMenu, errorMenu, menu]);

  return (
    <Nav
      id="accordionSidebar"
      className={`d-none d-md-block navbar-nav bg-gradient-primary sidebar ${
        menuCollapsed ? "toggled" : ""
      } sidebar-dark accordion`}
      activeKey="/app/home"
    >
      <Nav.Item className="align-center text-center mt-3">
        <Button
          className="d-none d-md-inline rounded-circle border-0"
          id="sidebarToggle"
          onClick={() => {
            setMenuCollapsed((curr) => !curr);
          }}
        >
          {menuCollapsed ? <BsArrowBarRight /> : <BsArrowBarLeft />}
        </Button>
      </Nav.Item>

      <hr className="sidebar-divider" />

      <Nav.Item key={-1}>
        {menuCollapsed ? (
          <OverlayTrigger
            placement="right"
            delay={{ show: 0, hide: 10 }}
            overlay={<Tooltip id="button-tooltip">Início</Tooltip>}
          >
            <Nav.Link onClick={() => history.push("/app/home")}>
              <span>
                <i className="fas fa-home" />
              </span>
              <span className="ocultarNoToggle">Início</span>
            </Nav.Link>
          </OverlayTrigger>
        ) : (
          <Nav.Link onClick={() => history.push("/app/home")}>
            <span>
              <i className="fas fa-home" />
            </span>
            <span className="ocultarNoToggle">Início</span>
          </Nav.Link>
        )}
      </Nav.Item>

      {menu.map((item, index) => {
        if (item.size) {
          return renderMenuRoot(menuCollapsed, item, index, history);
        }

        if (item.url) {
          return (
            <Fragment key={item.title}>
              <hr className="sidebar-divider" />
              <Nav.Item>
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 0, hide: 10 }}
                  overlay={<Tooltip id="button-tooltip">{item.title}</Tooltip>}
                >
                  <Nav.Link eventkey={item.title} onClick={() => history.push(item.url)}>
                    <span>
                      <i className={item.icon} />
                    </span>
                    <span className="ocultarNoToggle">{item.title}</span>
                  </Nav.Link>
                </OverlayTrigger>
              </Nav.Item>
            </Fragment>
          );
        }

        return null;
      })}
    </Nav>
  );
};

export default SideMenu;
